import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Tag from '@components/tag/Tag'

const TagsSection = () => {
  return (
    <Section>
      <SectionTitle>Tags</SectionTitle>
      <Row>
        <Container>
          <Tag item={{ label: 'Tag', value: 'tag' }} selected={false} onItemSelected={() => undefined} />
        </Container>
        <Container>
          <Tag item={{ label: 'Tag', value: 'tag' }} selected={true} onItemSelected={() => undefined} />
        </Container>
      </Row>

      <Row>
        <Container>
          <Tag focused item={{ label: 'Tag', value: 'tag' }} selected={false} onItemSelected={() => undefined} />
        </Container>
        <Container>
          <Tag focused item={{ label: 'Tag', value: 'tag' }} selected={true} onItemSelected={() => undefined} />
        </Container>
      </Row>
      <Row>
        <Container>
          <Tag
            item={{ label: 'Tag', value: 'tag' }}
            selected={false}
            rightIcon="arrow"
            onItemSelected={() => undefined}
          />
        </Container>
        <Container>
          <Tag
            item={{ label: 'Tag', value: 'tag' }}
            selected={true}
            rightIcon="cancel"
            onItemSelected={() => undefined}
          />
        </Container>
      </Row>
      <Row>
        <Container>
          <Tag item={{ label: 'Tag', value: 'tag' }} selected={false} onItemSelected={() => undefined} indicator={5} />
        </Container>
        <Container>
          <Tag item={{ label: 'Tag', value: 'tag' }} selected={true} onItemSelected={() => undefined} indicator={120} />
        </Container>
      </Row>
      <Row>
        <Container>
          <Tag
            activeColor
            focused
            item={{ label: 'Quitter la déclaration', value: 'tag' }}
            selected={false}
            leftIcon="close"
            onItemSelected={() => undefined}
          />
        </Container>
      </Row>
    </Section>
  )
}

export default TagsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Row = styled(View)`
  flex-flow: row wrap;
`
const Container = styled(View)`
  margin: 0 12px 24px 0;
`
